"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubPeriodicitePiervalCorporationTrads = void 0;
exports.ESubPeriodicitePiervalCorporationTrads = {
    mensuelle: "Mensuelle",
    trimestrielle: "Trimestrielle",
    annuelle: "Annuelle",
    neSaisPas: "Je ne sais pas",
    semestrielle: "Semestrielle",
};
